import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Portfolio from "../pages/portfolio/page";
import FAQPage from "../pages/faq/page";
import ContactPage from "../pages/contact/page";
import BrochureFma from "../pages/sales/brochure-fma/page";
import BrochureSrp01 from "../pages/sales/brochure-srp01/page";
import BrochureSrp02 from "../pages/sales/brochure-srp02/page";
import AdPage01 from "../pages/sales/ad01/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/portfolio",
    element: <Portfolio />,
  },
  {
    path: "/faq",
    element: <FAQPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/sales/brochure-fma",
    element: <BrochureFma />,
  },
  {
    path: "/sales/brochure-srp01",
    element: <BrochureSrp01 />,
  },
  {
    path: "/sales/brochure-srp02",
    element: <BrochureSrp02 />,
  },
  {
    path: "/sales/ad01",
    element: <AdPage01 />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
